import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import { AxiosResponse } from "axios";

import { editUser } from "../../../store/user/actions";
import { post } from "../../../actions/general";
import { IUser } from "../../../store/user/models";

import Form, { Radio, Title, Submit, Cancel } from "../../../components/Form";
import Modal from "../../../components/Modal";
import messages from "../messages";
import { IProps } from "./interfaces";
import { IRadioEvent } from "../../../types";

const ChangeRadioValue = ({ changingValue, close, changingName, changingLabel, options }:  IProps) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState(changingValue);
    const [validation, setValidation] = useState<string | undefined>(undefined);
    const [loading, setLoading] = useState(false);

    const submit = () => {
        let newValue: string | number = value;
        if (changingName === "gender") newValue = +newValue;
        setLoading(true);
        dispatch(post("change-" + changingName, { [changingName]: newValue }, (res: AxiosResponse<{ success: boolean, user: IUser }>) => {
            const { data } = res;
            if (data.success) {
                dispatch(editUser(data.user));
                close();
                return;
            } else {
                setValidation("unknownError");
            }
            setLoading(false);
        }));
    };
    const changeValue = (e: IRadioEvent) => {
        setValue(e.target.value);
        setValidation(undefined);
    };
    return (
        <Modal close={close}>
            <Form disabled={loading}>
                <Title>
                    <FormattedMessage {...messages.modifySomething} values={{ value: changingLabel }} />
                </Title>
                <Radio
                    disabled={loading}
                    validation={validation}
                    label={changingLabel}
                    value={value}
                    name={"value"}
                    onChange={changeValue}
                    options={options}
                />
                <Submit onClick={submit} loading={loading}>
                    <FormattedMessage {...messages.modify} />
                </Submit>
                <Cancel onClick={close}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}

export default ChangeRadioValue;
